import React from 'react';
import { Figure } from 'shared/ui/Figure';
import type { RackUnitModel } from 'shared/lib/rackLayout';

const TYPE_LABEL: Record<string, string> = {
  dNode: 'Director node', fNode: 'Flash node', sNode: 'Storage node', jbod: 'JBOD', 'jbod-8u': 'JBOD (8U)',
};

export function RackInspector({ unit }: { unit: RackUnitModel | null }) {
  return (
    <aside aria-label="Unit details" className="w-64 shrink-0 rounded-[var(--radius-2)] border border-hairline/15 bg-surface-raised p-3">
      {unit ? (
        <div className="flex flex-col gap-3">
          <Figure label="Unit" value={unit.label} />
          <Figure label="Type" value={TYPE_LABEL[unit.type] ?? unit.type} />
          <Figure label="Height" value={String(unit.heightU)} unit="U" />
          {unit.ssdInfo && <Figure label="Drives" value={unit.ssdInfo} />}
          {unit.jbodLabel && <Figure label="JBOD" value={unit.jbodLabel} />}
        </div>
      ) : (
        // P4: ink-muted takes no alpha suffix — the mute is a baked alpha already.
        <p className="font-body text-xs text-ink-muted">Select a unit to inspect it.</p>
      )}
    </aside>
  );
}
